import {mapState} from 'vuex'

export default mapState({
    symplaParticipations: state => state.session.user.symplaParticipations.filter(participation => {
        return participation.event.categories.includes('bars_restaurants') && participation.percentCompleted >= 90
    })
})
